import React, { useContext } from "react";
import { SiteContext } from "gatsby-frontend";
import { Navbar, Footer, AlertBanner, CookieAgreement, BackToTopFAB } from "../../";

/**
 * A layout to wrap public pages
 * contains public header and footer
 *
 * @param props.children the content of the page
 * @returns
 */

function Public({ children }) {
	const { navData, secondaryNavData, path } = useContext(SiteContext);

	return (
		<>
			<Navbar main={navData} tools={secondaryNavData} path={path} />
      <AlertBanner />
      <CookieAgreement />
      <BackToTopFAB />
			<div id="single-body">{children}</div>
			<Footer />
		</>
	);
}

export default Public;
